import BaseMixin from './base.mixin'

const mixin = {
  mixins: [BaseMixin],
  methods: {
    async getSurveyToAnswer(surveyId) {
      const response = await this.getClient().get('/core/surveys', {
        params: { surveyId }
      })
      return response.data?.data || response.data
    },

    async submitSurveyAnswers(payload) {
      const response = await this.getClient().post('/core/surveys', payload)
      return response
    }
  }
}
export default mixin
